import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { MapView } from '@/components/maps/map-view';
import { Clock, Navigation } from 'lucide-react';

export function TaskLocationMap() {
  // Mock data - replace with real data from your location tracking system
  const currentLocation = {
    lat: 40.7128,
    lng: -74.0060,
  };

  const nextTask = {
    location: {
      lat: 40.7589,
      lng: -73.9851,
    },
    title: 'HVAC Maintenance - Building A',
    distance: '2.5 miles',
    estimatedTime: '15 minutes',
  };

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>Location Tracking</CardTitle>
        <Badge variant="outline" className="flex items-center gap-1">
          <Navigation className="h-3 w-3" />
          GPS Active
        </Badge>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="h-[300px] rounded-lg overflow-hidden border">
            <MapView
              center={currentLocation}
              markers={[
                {
                  position: currentLocation,
                  title: 'Current Location',
                },
                {
                  position: nextTask.location,
                  title: nextTask.title,
                },
              ]}
              zoom={13}
            />
          </div>

          <div className="flex items-center justify-between rounded-lg border p-4">
            <div>
              <h3 className="font-medium">Next Task Location</h3>
              <p className="text-sm text-muted-foreground mt-1">
                {nextTask.title}
              </p>
            </div>
            <div className="text-right">
              <div className="flex items-center gap-2 text-sm">
                <span>{nextTask.distance}</span>
                <Clock className="h-4 w-4 text-muted-foreground" />
                <span>{nextTask.estimatedTime}</span>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}